import { render, staticRenderFns } from "./ComponentMandate.vue?vue&type=template&id=21878b11&scoped=true"
import script from "./ComponentMandate.vue?vue&type=script&lang=js"
export * from "./ComponentMandate.vue?vue&type=script&lang=js"
import style0 from "./ComponentMandate.vue?vue&type=style&index=0&id=21878b11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21878b11",
  null
  
)

export default component.exports